import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default function createRouter() {
  const routes = [
    {
      path: "/admin",
      name: "home",
      component: () => import("./views/home/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/ranging/workers",
      name: "ranging-workers",
      component: () => import("./views/content/ranging/pages/workers.vue"),
      meta: {
        type: 1,
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/ranging/banners",
      name: "ranging-banners",
      component: () => import("./views/content/ranging/pages/banners.vue"),
      meta: {
        type: 1,
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/ranging/activity",
      name: "ranging-activity",
      component: () => import("./views/content/ranging/index.vue"),
      meta: {
        type: 1,
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/ranging/about",
      name: "ranging-about",
      component: () => import("./views/content/ranging/index.vue"),
      meta: {
        type: 2,
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/login",
      name: "login",
      component: () => import("./views/auth/login.vue"),
      meta: {
        hideComponents: true,
      },
    },
    {
      path: "/admin/password/reset",
      name: "passwordreset",
      component: () => import("./views/auth/reset.vue"),
      meta: {
        hideComponents: true,
      },
    },
    {
      path: "/admin/password/change",
      name: "password",
      component: () => import("./views/auth/password.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/upload",
      name: "upload",
      component: () => import("./views/upload/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/profile",
      name: "profile",
      component: () => import("./views/auth/profile.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/user/:id?",
      name: "user",
      component: () => import("./views/content/user/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/service/:id?",
      name: "service",
      component: () => import("./views/content/service/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/act/:id?",
      name: "act",
      component: () => import("./views/content/act/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/activity/:id?",
      name: "activity",
      component: () => import("./views/content/activity/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/banner/:id?",
      name: "banner",
      component: () => import("./views/content/banner/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/category/:id?",
      name: "category",
      component: () => import("./views/content/category/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/subdepartmentcategory/:id?",
      name: "subdepartmentcategory",
      component: () => import("./views/content/subdepartmentcategory/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/section/:id?",
      name: "section",
      component: () => import("./views/content/section/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/contact/:id?",
      name: "contact",
      component: () => import("./views/content/contact/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/faq/:id?",
      name: "faq",
      component: () => import("./views/content/faq/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/documenttype/:id?",
      name: "documenttype",
      component: () => import("./views/content/documenttype/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/link/:id?",
      name: "link",
      component: () => import("./views/content/link/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/news/:id?",
      name: "news",
      component: () => import("./views/content/news/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/post/:id?",
      name: "post",
      component: () => import("./views/content/post/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/subdepartment/:id?",
      name: "subdepartment",
      component: () => import("./views/content/subdepartment/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/worker/:id?",
      name: "worker",
      component: () => import("./views/content/worker/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/department/:id?",
      name: "department",
      component: () => import("./views/content/department/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/minister",
      name: "minister",
      component: () => import("./views/content/minister/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/appeal/:id",
      name: "appeal",
      component: () => import("./views/content/appeal/index.edited.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/appeals",
      name: "appeals",
      component: () => import("./views/content/appeal/list"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/sections",
      name: "sections",
      component: () => import("./views/sections/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/division/:id?",
      name: "division",
      component: () => import("./views/content/division/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/divisions",
      name: "divisions",
      component: () => import("./views/content/division/list"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("./views/PageNotFound.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
  ];
  const router = new Router({
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      if (to.hash) {
        return {
          selector: to.hash,
          behavior: "smooth",
        };
      }
      return { x: 0, y: 0 };
    },
    fallback: true,
    routes,
  });
  // Проверка на доступность страницы
  router.beforeEach((to, from, next) => {
    if (window.user && window.user.roles) {
      let roles = window.user.roles.map((r) => r.name);
      if (!(to.meta.allowedRoles && to.meta.allowedRoles.some((r) => r === "*" || roles.includes(r)))) {
        next(false);
        return;
      }
    }
    next();
  });

  return router;
}
